import { request } from 'api';

class LocalitiesApi {
  static get() {
    // unauthenticated request
    return request(`localities`);
  }
}

export default LocalitiesApi;
